import cx from 'classnames';
import styles from './ActionLink.module.scss';
import Button from '../../components/Button';

function ActionLink({
  style,
  title = '',
  title2 = '',
  onClick = null,
  onClick2 = null,
  titleStyle = {},
  titleClassName = '',
  titleStyle2 = {},
  titleClassName2 = '',
  icon = null,
}) {
  const Icon = icon;
  if (!title) return null;
  return (
    <div className="d-flex align-items-center gap-2">
      {(title2 || onClick2) && (
        <Button
          color="link"
          className={cx('p-0 h-auto', styles.link)}
          style={style}
          onClick={onClick2}>
          {Icon}
          <span style={titleStyle2} className={cx(styles.title, titleClassName2)}>
            {title2}
          </span>
        </Button>
      )}
      {(title || onClick) && (
        <Button
          color="link"
          className={cx('p-0 h-auto', styles.link)}
          style={style}
          onClick={onClick}>
          {Icon}
          <span style={titleStyle} className={cx(styles.title, titleClassName)}>
            {title}
          </span>
        </Button>
      )}
    </div>
  );
}

export default ActionLink;
